export default __webpack_public_path__ + "locales/uk-UA/DeleteSelfProfileDialog.json?hash=1e42ae0559e01bc6a7cb075bbfd19b7c";